import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { css } from 'styled-components';
//SDS
import Word from 'saur-design-sys-web/lib/Atoms/Word/Word';
import Button from 'saur-design-sys-web/lib/Atoms/Input/Button/Button';
//SVSM
import { getLanguage } from 'saur-viseau-state-management/lib/settings/selectors';
// internal
import { RouteTypes, usePath } from '../../common/navigation';
import ID_VALUES from '../../automated-tests-ids/ids';

type Props = {
    mode: 'button';
};

const AccessibilitySettings: FC<Props> = ({ mode }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { getPath } = usePath();
    const lang = useSelector(getLanguage) as string;

    if (mode !== 'button') return null;

    const handleClick = () => {
        history.push(`/${lang}${getPath(RouteTypes.ACCESSIBILITY)}`);
    };

    return (
        <Button
            mode='basic'
            automatedTestId={ID_VALUES.footer.links.accessibility}
            onClick={handleClick}
        >
            <Word
                className='NavLink'
                value={t('accessibility.buttonLabel')}
                textStyle='tinyMedium'
                variant='span'
            />
        </Button>
    );
};

export const AccessibilitySettingsStyles = css``;

export default AccessibilitySettings;
